<section class="description-edit-container">
  <div class="back-btn" (click)="closeDescription.emit()">
    <svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none">
    <path d="M3.7598 0.399609L4.90039 1.52169L2.38443 3.99961L4.90039 6.47753L3.7598 7.59961L0.100392 3.99961L3.7598 0.399609Z" fill="black"/>
  </svg>
    Back
  </div>
  <div class="description-container-title">
    Site description
  </div>
  <div class="description-container-subtitle">
    Your future site content will be generated based on this description.
  </div>

  <textarea class="ds-textarea ds-textarea-black" [class.error]="descriptionControl.dirty && descriptionControl.invalid" [formControl]="descriptionControl">

  </textarea>
  <div class="actions-container">
    <div class="invalid-description" *ngIf="descriptionControl.dirty && descriptionControl.invalid && descriptionControl.hasError('maxlength')">
      {{descriptionControl?.value?.length}} / 1000
    </div>
<!--    <div class="invalid-description" *ngIf="descriptionControl.dirty && descriptionControl.invalid && descriptionControl.hasError('minlength')">-->
<!--      To get better results input no less than 20 symbols-->
<!--    </div>-->
    <div class="apply-btn">
      <span [class.disabled]="!descriptionControl.dirty || (descriptionControl.dirty && descriptionControl.invalid)" (click)="saveChanges()">{{ 'text_applyChanges' | dbText }}</span>
    </div>
  </div>
</section>
